import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { I18nextProvider } from "react-i18next";
import AppRouter from "./AppRouter";
import i18n from "./i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  //NOTE: Strictmode habilita dobles llamados a algunos hooks lo que puede provocar llamados duplicados a webservices
  //Esto no ocurre cuando se hace build en produccion
  //<React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <AppRouter />
    </I18nextProvider>
  //</React.StrictMode>
);
